import { useRef, useEffect } from 'react';
import RailzConnect from '@railzai/railz-connect';
import { RAILZ_SERVICES, RailzServiceNames } from 'vopay';
import RailzConnectType from './railz-connect';
import styles from './RailzConnect.module.scss';

export type RailzConnectProps = {
  redirectURL: string;
  /** Where the widget's close button lands; must not re-open the widget, or the flow has no exit */
  closeRedirectURL?: string;
  widgetId: string;
  businessName: string;
  /** Restricts the widget to this one service (an ERP card was clicked); omit to let the user pick */
  service?: RailzServiceNames;
};

// The widget only supports an exclude list, so "show one service" means excluding every other one
function servicesToExclude(selected: RailzServiceNames): RailzServiceNames[] {
  return RAILZ_SERVICES.filter((service) => service !== selected);
}

export default function RailzConnectFrame({
  redirectURL,
  closeRedirectURL,
  widgetId,
  businessName,
  service,
}: RailzConnectProps) {
  const ref = useRef(null);

  useEffect(() => {
    const widget: RailzConnectType = new (RailzConnect as typeof RailzConnectType)();

    widget.mount({
      parentElement: ref.current,
      widgetId,
      businessName,
      brandColor: '000000',
      accentColor: 'FFFFFF',
      language: 'en',
      redirectUrl: redirectURL,
      closeRedirectUrl: closeRedirectURL || redirectURL,
      removeRailzWatermark: true,
      closeEnabled: true,
      options: service ? { services: { exclude: servicesToExclude(service) } } : undefined,
    });
  }, []);

  return <div className={styles.railzConnectContainer} id="railz-connect" ref={ref} data-service={service} />;
}
